/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-tick-sm': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<defs><path pid="0" d="M9.134 1.13a.497.497 0 0 1 .793.592l-.054.072L3.525 8.87a.497.497 0 0 1-.633.089l-.072-.055L.161 6.47a.497.497 0 0 1 .6-.787l.071.054L3.12 7.832 9.134 1.13z" id="svgicon-icon-tick-sm-a"/></defs><use _fill="#376F99" xlink:href="#svgicon-icon-tick-sm-a" fill-rule="evenodd"/>'
  }
})
